<form [formGroup]="editDsRecordsForm" (ngSubmit)="onSubmit()">
    <div class="form-error is-visible" *ngIf="emptyTrustAnchorsErrorMessage">
        {{emptyTrustAnchorsErrorMessage}}
    </div>
    <div class="grid-x">
        <div class="cell large-2 medium-1 small-4 content-header cell-margin-right" style="padding-left: 24px">Key Tag</div>
        <div class="cell large-2 medium-2 small-4 content-header cell-margin-right">Key Algorithm</div>
        <div class="cell large-2 medium-2 small-4 content-header cell-margin-right"> Digest Type</div>
        <div class="cell auto content-header">Key Digest</div>
    </div>
    <div formArrayName="formDsRecords">
        <div *ngFor="let ds of formDsRecords.controls; let i=index;">
            <div class="grid-x">
                <div class="cell large-2 medium-12 small-12 cell-margin-right" [formGroupName]="i">
                    <fa-icon (click)="removeDsRecord(i)" [icon]="'trash'" class="delete-icon align-center cell-margin-right" style="display: inline"></fa-icon>
                    <input type="number" id="key-tag"
                           formControlName="keyTag"
                           class="input-group-custom"
                           placeholder="Key Tag"
                           maxlength="20"
                           style="display: inline">
                    <div class="form-error is-visible" *ngIf="keyTag(i).touched && keyTag(i).errors">
                        <span>{{keyTag(i).errors}}</span>
                    </div>
                </div>
                <div class="cell large-2 medium-12 small-12 cell-margin-right" [formGroupName]="i">
                    <select formControlName="algorithm"
                            aria-describedby="Select a Key Algorithm" required>
                        <option *ngFor="let keyAlg of keyAlgs" [value]="keyAlg.name">
                            {{keyAlg.value}} ({{keyAlg.name}})
                        </option>
                    </select>
                </div>
                <div class="cell large-2 medium-12 small-12 cell-margin-right" [formGroupName]="i">
                    <select formControlName="digestType"
                            aria-describedby="Digest Type" required>
                        <option *ngFor="let digestType of digestTypes" [value]="digestType.name">
                            {{digestType.value}} ({{digestType.name}})
                        </option>
                    </select>
                </div>
                <div class="cell auto" [formGroupName]="i">
                    <input formControlName="digest"
                           placeholder="Key Digest"
                           class="input-group-custom"
                           maxlength="100">
                    <div class="form-error is-visible" *ngIf="digest(i).touched && digest(i).errors">
                        <span>{{digest(i).errors}}</span>
                    </div>
                </div>

            </div>
        </div>

        <a class="a-link" (click)="addAdditionalDS()">Add new ds record</a>
    </div>
    <div class="grid-x save-cancel-button-group">
        <button class="iana-button-cancel" (click)="cancel()">{{newDelegation ? "Previous" : "Cancel"}}</button>
        <button class="iana-button" type="submit" [disabled]="editDsRecordsForm.invalid">{{newDelegation ? "Next" : "Save"}}</button>
    </div>
</form>
